"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var CheckboxPrimitive = _interopRequireWildcard(require("@radix-ui/react-checkbox"));
var _reactIcons = require("@radix-ui/react-icons");
var _Flex = _interopRequireDefault(require("./Flex"));
require("./Checkbox.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Checkbox = function Checkbox(_ref) {
  var customID = _ref.customID,
    children = _ref.children,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  return children ? /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    align: "center",
    gap: 100
  }, /*#__PURE__*/_react["default"].createElement(CheckboxPrimitive.Root, {
    className: "CheckboxRoot",
    id: customID,
    checked: checked,
    onCheckedChange: onChange,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(CheckboxPrimitive.Indicator, {
    className: "CheckboxIndicator"
  }, /*#__PURE__*/_react["default"].createElement(_reactIcons.CheckIcon, null))), /*#__PURE__*/_react["default"].createElement("label", {
    className: "Label",
    htmlFor: customID
  }, children)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CheckboxPrimitive.Root, {
    className: "CheckboxRoot",
    id: customID,
    checked: checked,
    onCheckedChange: onChange,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(CheckboxPrimitive.Indicator, {
    className: "CheckboxIndicator"
  }, /*#__PURE__*/_react["default"].createElement(_reactIcons.CheckIcon, null))));
};
var _default = exports["default"] = Checkbox;